<template>
  <div>
    <div class="container">
      <article class="message is-info">
        <div class="message-header large">
          <p>Update 14/11/2019 11:29AM</p>
          <!-- <button class="delete" aria-label="delete"></button> -->
        </div>
        <div class="message-body medium">
          <ul>
            <li>Updated calculations for 2019 season - Includes home games only for now...</li>
          </ul>
        </div>
      </article>
    </div>
    <article class="is-parent box">
    <h1 class="title has-text-centered">Season Totals</h1>
    <season-totals-menu name="shot-differentials"></season-totals-menu>
     <section id="gameFilters">
      <div class="is-parent  is-vertical">
      <article class="is-child box">
        <h2 class="subtitle"><b>Filters</b></h2>
          <div class="columns">
            <div class="column is-3">
              <label class="label">Season</label>
              <div class="control">
                <div class="select">
                  <select v-model="YearSelected" @change="fetchSeasonStats">
                    <option value=2022>2022-2023</option>
                    <option value=2019>2019-2020</option>
                    <option value=2018>2018-2019</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <label class="label">Competition</label>
              <div class="control">
                <div class="select">
                  <select v-model="CompetitionSelected"  @change="fetchSeasonStats">
                    <option v-for="option in CompetitionOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
              <div class="column is-4">
                <label class="label">Opponent</label>
                <div class="control">
                  <div class="select">
                    <select  v-model="OpponentSelected"  @change="fetchSeasonStats">
                      <option v-for="option in OpponentOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
            <div class="column is-5">
              <label class="label">Venue</label>
              <div class="control">
                <div class="select">
                  <select v-model="VenueSelected"  @change="fetchSeasonStats">
                    <option v-for="option in VenueOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-4">
                <label class="label">Limit</label>
                <div class="control">
                  <div class="select">
                    <select v-model="LimitSelected" @change="fetchSeasonStats">
                      <option v-for="option in LimitOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
          </div>
        </article>
      <data-table id="Filtered Games" heading="Filtered Games" v-bind:headers="FilterHeadings" v-bind:tableData="GameFilter"></data-table>
      </div>
    </section>
    </article>
 
    <section id="player_shot_diff">
      <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="player_corsi" heading="Player Shot Differentials - Home games only will be updated with both shortly..." v-bind:headers="PlayerShotDiffHeadings" v-bind:tableData="sortByPlayerShotDiffData">
          <div slot="graph">
          </div>
          <div slot="filter">
            <div class="column is-2 is-small">
              <label class="label">Situation</label>
              <div class="control">
                <div class="select">
                  <select v-model="SituationSelected" @change="fetchSeasonStats">
                    <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </data-table>
      </div>
    </section>
    <section id="player_last_five">
      <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="player_corsi" heading="Player Shot Differentials - Home games only will be updated with both shortly..." v-bind:headers="PlayerShotDiffHeadings" v-bind:tableData="sortByPlayerShotDiffData">
          <div slot="graph">
          </div>
          <div slot="filter">
          </div>
        </data-table>
      </div>
    </section>

  </div>
</template>
<script>
import DataTable from '../data-table'
import SubTable from '../sub-table'
import SeasonTotals from '../season-totals-menu'
import simpleheat from '../../../store/modules/simpleheat/simpleheat'
import Chart from 'vue-bulma-chartjs'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
export default {
  components: {
    'data-table': DataTable,
    'sub-table': SubTable,
    'season-totals-menu': SeasonTotals,
    'simpleheat': simpleheat,
    Multiselect,
    Chart
  },
  data () {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      PlayerOptions: [],
      ShotTypeOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 1,
      LimitSelected: 0,
      PlayerSelected: [],
      ShotTypeSelected: 0,
      FilterSelected: 'so_total',
      BlurSelected: 25,
      RadiusSelected: 12,
      UseHeatmap: true,
      ShotsPlayerData: [],
      FilterHeadings: [],
      ShotsPlayerHeadings: [
        'Player',
        'GP',
        'G',
        'On Net',
        'Missed',
        'Blocked',
        'OnNet%',
        'SH%',
        'Total',
        'OnNetAvg',
        'ShotAvg'
      ],
      ShotsPlayerFilters: [
        {text: 'Player', value: 'player'},
        {text: 'GP', value: 'gp'},
        {text: 'G', value: 'goals'},
        {text: 'On Net', value: 'so_on_net'},
        {text: 'Missed', value: 'so_missed_net'},
        {text: 'Blocked', value: 'so_blocked'},
        {text: 'OnNet%', value: 'so_on_net_percentage'},
        {text: 'SH%', value: 'so_goal_percentage'},
        {text: 'Total', value: 'so_total'},
        {text: 'OnNetAvg', value: 'so_on_net_avg'},
        {text: 'ShotAvg', value: 'so_total_avg'}
      ],
      TeamShotDiffData: [],
      TeamShotDiffHeadings: [
        'Player',
        'Home Team',
        'Away Team',
        'Date',
        'CF',
        'CA',
        'Diff',
        'CF%'
      ],
      PlayerShotDiffData: [],
      PlayerShotDiffHeadings: [
        'Player',
        'GP',
        'CF',
        'CA',
        'Diff',
        'CF%'
      ],
      PlayerShotmapData: [],
      PlayerShotmapHeadings: [
        'Player',
        'Shot Id',
        'Shot Type',
        'Shot Location'
      ],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      line_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      lastFiveData: [],
      lastFiveDataSeries: [],
      lastFiveChartOptions: {
        chart: {
          toolbar: { show: false },
          colors: [],
          title: { text: 'Last Five Games Shot Differential' },
          markers: { size: 6 },
          theme: {
            palette: 'pallette3'
          },
          yaxis: {
            title: 'Shot Differential'
          },
          xaxis: {
            title: 'Game(s)'
          }
        }
      }
    }
  },
  computed: {
    sortByShotsData: function () {
      return _.orderBy(this.ShotsPlayerData, this.FilterSelected, ['desc'])
    },
    sortByTeamShotDiffData: function () {
      return _.orderBy(this.TeamShotDiffData, 'id', ['asc'])
    },
    sortByPlayerShotDiffData: function () {
      return _.orderBy(this.PlayerShotDiffData, 'diff', ['desc'])
    },
    sortByPlayerShotmapData: function () {
      return _.orderBy(this.PlayerShotmapData, 'shot_id', ['desc'])
    },
    sortByShotsDataChart: function () {
      let orderedData = this.sortByShotsData
      return _.map(orderedData, this.FilterSelected)
    },
    sortByTeamShotDiffDataChart: function () {
      let orderedData = this.sortByTeamShotDiffData
      return _.map(orderedData, 'cf_percent')
    },
    chartData: function () {
      let playerLabels = []
      for (var label of this.sortByShotsData) {
        playerLabels.push(label.player)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: this.sortByShotsDataChart,
        label: 'Shots - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    },
    chartTeamDiffData: function () {
      let playerLabels = []
      for (var label of this.TeamShotDiffData) {
        if (label.match_date !== '2018-2019') {
          playerLabels.push(label.match_date)
        }
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: this.sortByTeamShotDiffDataChart,
        label: 'Team Shot Differential - CF % ',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(0, 225, 225, 1)',
        pointBorderColor: 'rgba(0, 225, 255, 1)',
        pointBackgroundColor: 'rgba(0, 225, 255, 1)',
        fill: false
      }]
      return data
    }
  },
  methods: {
    fetchSeasonStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'limit': this.LimitSelected
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/shot-diff', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.GameFilter = response.data.games_filter
            this.ShotsPlayerData = response.data.shots
            this.PlayerShotDiffData = response.data.shot_differentials_player
            this.TeamShotDiffData = response.data.shot_differentials_team
            this.lastFiveData = response.data.shot_differentials_last_five

            for (var d of this.lastFiveData) {
              this.lastFiveDataSeries.data.push({x: d.game_info, y: d.diff})
            }
          },
          response => {}
        )
    },
    fetchFilterOptions () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(
          response => {
            // console.log(response.data)
            let venue = response.data.venue
            this.VenueOptions.push({text: 'All', value: 0})
            for (var i = 0; i < venue.length; i++) {
              this.VenueOptions.push({text: venue[i].location, value: venue[i].location})
            }

            let opponent = response.data.teams
            this.OpponentOptions.push({text: 'All', value: 0})
            for (var j = 0; j < opponent.length; j++) {
              if (opponent[j].id !== '1') {
                this.OpponentOptions.push({text: opponent[j].name, value: opponent[j].id})
              }
            }
            let player = response.data.cardiff_players
            this.PlayerOptions.push({name: 'All', id: 0})
            for (var p = 0; p < player.length; p++) {
              this.PlayerOptions.push({name: player[p].number + ' ' + player[p].surname, id: player[p].id})
            }
            let situations = response.data.situations
            this.SituationOptions.push({text: 'All', value: 0})
            this.SituationOptions.push({text: '--Primary Situations--', value: -6})
            this.SituationOptions.push({text: 'Even Handed', value: 1})
            this.SituationOptions.push({text: 'Power Play', value: 2})
            this.SituationOptions.push({text: 'Short Handed', value: 3})
            this.SituationOptions.push({text: 'Empty Net', value: 4})
            this.SituationOptions.push({text: '--Not avalible yet - Secondary Situations--', value: -5})
            for (var s = 0; s < situations.length; s++) {
              // this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
            }
            this.CompetitionOptions.push({text: 'All', value: 0})
            this.CompetitionOptions.push({text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup'})
            this.CompetitionOptions.push({text: 'EIHL', value: 'EIHL'})
            this.CompetitionOptions.push({text: 'Challenge Cup', value: 'Challenge-Cup'})
            this.CompetitionOptions.push({text: 'Pre-Season', value: 'Pre-Season'})
            this.CompetitionOptions.push({text: 'Playoffs', value: 'Playoffs'})
            this.CompetitionOptions.push({text: 'CHL', value: 'CHL'})

            this.PeriodOptions.push({text: 'All', value: 0})
            this.PeriodOptions.push({text: 'Period 1', value: 1})
            this.PeriodOptions.push({text: 'Period 2', value: 2})
            this.PeriodOptions.push({text: 'Period 3', value: 3})
            this.PeriodOptions.push({text: 'Period OT', value: 4})
            this.PeriodOptions.push({text: 'Period Shootout', value: 5})

            this.LimitOptions.push({text: 'All', value: 0})
            this.LimitOptions.push({text: '5 Games', value: 5})
            this.LimitOptions.push({text: '10 Games', value: 10})
            this.LimitOptions.push({text: '20 Games', value: 20})

            this.ShotTypeOptions.push({text: 'All', value: 0})
            this.ShotTypeOptions.push({text: 'Goal', value: 'Goal'})
            this.ShotTypeOptions.push({text: 'On Net', value: 'OnNet'})
            this.ShotTypeOptions.push({text: 'Missed Net', value: 'MissedNet'})
            this.ShotTypeOptions.push({text: 'Blocked', value: 'Blocked'})
          }
        )
    }
  },
  created () {
    this.fetchSeasonStats()
    this.fetchFilterOptions()
  }
}
</script>
<style>
#fixed-div {
    position: fixed;
    top: 1em;
    right: 1em;
}
</style>



// WEBPACK FOOTER //
// shot-differentials.vue?2b8e7fe2